
<div class="page-header">
    <a routerLink="/activiteit-typen/overzicht" class="page-header__back">
        <i class="fa-regular fa-chevron-left"></i>
    </a>
    <h1 class="page-header__title">{{ "activity-types.title" | translate }}</h1>
    <div class="page-header__actions"></div>
</div>

<app-activity-type-detail-form [activityType]="activityType$ | async" (submitted)="submit($event)" [errors]="errors$ | async" [loading]="loading$ | async"/>